module.exports = __webpack_public_path__ + "img/qy (23).4fbbf551.jpg";